import { type ErrorType } from "@vega-api/configs/customClientQuery";
import { getErrorMessage } from "@vega-api/custom/utils/errorHandling";
import { useToast } from "@vega-core/components/Toast/useToast";

export const useMutationErrorToast = () => {
  const showToast = useToast();

  return (fallbackMessage: string) => (error: ErrorType<unknown>) => {
    const { title, description } = getErrorMessage(error, {
      defaultTitle: fallbackMessage,
      defaultMessage: fallbackMessage,
    });
    showToast({ title, description, variant: "destructive" });
  };
};
